import script from "./NewsletterSubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsletterSubscription.vue?vue&type=script&setup=true&lang=js"

import "./NewsletterSubscription.vue?vue&type=style&index=0&id=58a66d74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a66d74"]])

export default __exports__